import { useFormikContext, getIn, Field } from "formik";
import { Switch } from "src/sudokit/components/Switch";

function CostControlsBlockEditor({ optionsPath }) {
  const { values, setFieldValue } = useFormikContext();
  const blockOptions = getIn(values, optionsPath);

  return (
    <Field name={`${optionsPath}.free`}>
      {({ field }) => (
        <Switch
          label="Free"
          checked={field.value}
          onCheckedChange={(checked) => {
            setFieldValue(optionsPath, { ...blockOptions, free: checked });
          }}
        />
      )}
    </Field>
  );
}

export default CostControlsBlockEditor;
